import modals from './Course_info_modals';
import steps from './Course_info_steps';
import stats from './Course_info_stats';
import content from './Course_content';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
    modals,
    steps,
    stats,
    content,
  },
  state: {
    snackbar              : false,
    test_hided            : false,
    content_mobile_showed : false,
    course_started        : false,
    course_completed      : false,
    test_started          : false,
    test_finished         : false,
    test_result           : false,
    interrupt_test        : false,
    course_name           : '',
    started_course_name   : '',
    started_course_id     : 0,
    current_lesson        : 0,
    next_lesson           : 0,
    lessons_passed        : 0,
    points_earned_test    : 5,
    points_total_test     : 5,
    points_required_test  : 5,
    course_time           : 1,
    course_rest_time      : '',
    expired               : false,
    time_test             : 0,
    date_start            : '',
    date_end              : '',
    mandatory             : true,
    test_attempts         : 0,
    test_remain_in_seconds: 0,
    series                : 0,
    completed_date        : 0,
    time_left             : 0,
    type                  : '',
  },
  getters: {
    type                  : ({type}) => type,
    course_time           : ({course_time}) => course_time,
    series                : ({series}) => series,
    completed_date        : ({completed_date}) => completed_date,
    course_rest_time      : ({course_rest_time}) => course_rest_time,
    expired               : ({expired}) => expired,
    test_attempts         : ({test_attempts}) => test_attempts,
    snackbar              : ({snackbar}) => snackbar,
    course_name           : ({course_name}) => course_name,
    course_started        : ({course_started}) => course_started,
    course_completed      : ({course_completed}) => course_completed,
    test_started          : ({test_started}) => test_started,
    test_finished         : ({test_finished}) => test_finished,
    test_result           : ({test_result}) => test_result,
    test_hided            : ({test_hided}) => test_hided,
    current_lesson        : ({current_lesson}) => current_lesson,
    next_lesson           : ({next_lesson}) => next_lesson,
    lessons_passed        : ({lessons_passed}) => lessons_passed,
    points_earned_test    : ({points_earned_test}) => points_earned_test,
    points_total_test     : ({points_total_test}) => points_total_test,
    points_required_test  : ({points_required_test}) => points_required_test,
    date_start            : ({date_start}) => date_start,
    date_end              : ({date_end}) => date_end,
    mandatory             : ({mandatory}) => mandatory,
    time_left             : ({time_left}) => time_left,
    time_test             : ({time_test}) => time_test,
    test_remain_in_seconds: ({test_remain_in_seconds}) => test_remain_in_seconds,
    content_mobile_showed : ({content_mobile_showed}) => content_mobile_showed,
    time_test_formatted   : ({time_test}) => {
      let now = new Date();
      let minutes = now.getMinutes();
      let time = now.setMinutes(minutes+time_test);
      time = new Date(time);
      return time;
    },
  },
  mutations: {
    SET_STATE_COURSE(state, payload) {
      state[payload.type] = payload.items;
    },
    SET_ACTIVE_COURSE(state, {id, name}) {
      state.started_course_id = id;
      state.started_course_name = name;
    },
    ENABLE_SNACKBAR(state) {
      state.snackbar = true;
    },
    DISABLE_SNACKBAR(state) {
      state.snackbar = false;
    },
    TOGGLE_SNACKBAR(state) {
      state.snackbar = !state.snackbar;
    },
    START_COURSE(state) {
      state.course_started = true;
    },
    COMPLETE_COURSE(state) {
      state.course_completed = true;
    },
    START_TEST(state) {
      state.test_started = true;
    },
    CANCEL_TEST(state) {
      state.test_started = false;
    },
    TEST_NOT_FINISHED(state) {
      state.test_finished = false;
    },
    FINISH_TEST(state) {
      state.test_finished = true;
    },
    SET_TEST_RESULT(state, result) {
      state.test_result = result;
    },
    POINTS_ADDED(state) {
      state.lessons_passed++;
    },
    POINTS_TOTAL_TEST(state) {
      state.lessons_passed=0;
    },
    NEXT_LESSON(state) {
      state.current_lesson++;
    },
    TEST_HIDE(state) {
      state.test_hided = true;
    },
    TEST_NOT_HIDDEN(state) {
      state.test_hided = false;
    },
    SHOW_MOBILE(state) {
      state.content_mobile_showed = true;
    },
    HIDE_MOBILE(state) {
      state.content_mobile_showed = false;
    },
    UPDATE_REMAIN_COURSE(state, time) {
      state.test_remain_in_seconds = time;
    },
    SET_COURSE(state, new_state) {
      Object.assign(state, new_state);
    },
    SET_EARNED_POINTS(state, value) {
      state.points_earned_test = value;
    },
    SET_TEST_ATTEMPTS(state, value) {
      state.test_attempts = value;
    },
    SET_TIME_REMAIN(state, value) {
      state.test_remain_in_seconds = value;
    },
  },
  actions: {
    async get_course_by_id({commit}, id) {
      try {
        commit('common/LOADING_ON', '', {root: true});
        const course_id = await api.course.get_course_by_id(id);
        commit('SET_COURSE', course_id.data.Course_info);
        console.debug("course_id.data", course_id.data)
        commit('course_info/steps/SET_COURSE_STEPS', course_id.data.Course_info_steps, {root: true});
        commit('course_info/content/SET_COURSE_ID', course_id.data.Course_content.course_id, {root: true});
        commit('course_info/content/SET_COURSE_CONTENT', course_id.data.Course_content.course_content, {root: true});
        commit('common/LOADING_OFF', '', {root: true});
      } catch (err) {
        console.error(err);
      }
    },
    async course_activate({commit, dispatch, rootGetters}, id) {
      const user = rootGetters['profile/user/user'];
      let obj = {
        'course_id': Number(id),
        'user_id'  : Number(user.id),
      };
      try {
        await api.course.activate_course(obj);
        commit('START_COURSE');
        dispatch('get_course_by_id', id);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
